<template>
  <div class="content-container">
    <search-comp @onSearch="attachData" @onReset="onResetParams">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Thông tin khách sạn</div>
                <input
                  v-model="searchParams.keyword"
                  type="text"
                  placeholder=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>
    <div class="container flex flex-1">
      <div v-loading="loading" class="das-layout gap-20 flex-1">
        <div class="l-w-50 flex">
          <div class="content-box flex-1">
            <div class="section-box outline">
              <div class="das-form-container">
                <div class="das-form-title-container justify-space-between">
                  <div class="das-form-title">
                    <span class="das-info-title">Danh sách khách sạn</span>
                  </div>
                </div>
                <hr />
                <GridVx
                  ref="agGrid"
                  :columns="columns"
                  :auto-size-cell="true"
                  :auto-select-first-row="false"
                  :rows="rows"
                  dom-layout="scroll"
                  class="agGrid"
                  @selectionChanged="onSelectionChange"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="l-w-50 flex">
          <div class="content-box flex-1">
            <div v-loading="loadingHotelView" class="section-box outline">
              <div class="das-form-title">
                <span class="das-info-title">Thông tin khách sạn</span>
              </div>
              <hr />
              <div class="flex justify-center">
                <div
                  style="
                    height: 200px;
                    width: 200px;
                    text-align: center;
                    margin: 20px 0;
                  "
                  class="img-container"
                >
                  <img
                    v-if="receivedImg"
                    style="width: 400px; height: 100%"
                    :src="receivedImg"
                  />
                </div>
              </div>
              <InfoList :columns="1">
                <InfoListLabel>ID khách sạn</InfoListLabel>
                <InfoListValue style="max-width: 500px">{{
                  hotelInfo.hotel_id
                }}</InfoListValue>

                <InfoListLabel>Tên</InfoListLabel>
                <InfoListValue style="max-width: 500px">{{
                  hotelInfo.name
                }}</InfoListValue>

                <InfoListLabel>Tên tiếng Anh</InfoListLabel>
                <InfoListValue style="max-width: 500px">{{
                  hotelInfo.name_en
                }}</InfoListValue>

                <InfoListLabel>Tổng số phòng</InfoListLabel>
                <InfoListValue style="max-width: 500px">{{
                  hotelInfo.total_room
                }}</InfoListValue>

                <InfoListLabel style="align-self: start"
                  >Hạng phòng</InfoListLabel
                >
                <InfoListValue style="max-width: 500px">
                  <ul
                    class="m-0"
                    style="
                      max-height: 200px;
                      overflow: auto;
                      padding-left: 20px;
                    "
                  >
                    <li
                      v-for="(item, index) in hotelInfo.room_level_detail"
                      :key="index"
                    >
                      <div class="flex">
                        <span>{{ item.room_level_nm }}</span>
                        <span> - </span>
                        <span style="display: inline-block; width: 100px">
                          {{ item.num_of_room }} phòng</span
                        >
                      </div>
                    </li>
                  </ul>
                </InfoListValue>

                <!-- <InfoListLabel>Tên ngắn</InfoListLabel>
                <InfoListValue>{{ hotelInfo.short_name }}</InfoListValue>

                <InfoListLabel>Website</InfoListLabel>
                <InfoListValue>{{ hotelInfo.website }}</InfoListValue>

                <InfoListLabel>Quốc gia</InfoListLabel>
                <InfoListValue>{{ hotelInfo.nation_id }}</InfoListValue>

                <InfoListLabel>Địa chỉ</InfoListLabel>
                <InfoListValue>{{ hotelInfo.address }}</InfoListValue>

                <InfoListLabel>Số điện thoại</InfoListLabel>
                <InfoListValue>{{ hotelInfo.phone_number }}</InfoListValue>

                <InfoListLabel>Fax</InfoListLabel>
                <InfoListValue>{{ hotelInfo.fax }}</InfoListValue>

                <InfoListLabel>Tên công ty</InfoListLabel>
                <InfoListValue>{{ hotelInfo.company_name }}</InfoListValue>

                <InfoListLabel>Năm thành lập</InfoListLabel>
                <InfoListValue>{{ hotelInfo.founded_year }}</InfoListValue>

                <InfoListLabel>Email</InfoListLabel>
                <InfoListValue>{{ hotelInfo.email }}</InfoListValue>

                <InfoListLabel>Mã bưu điện</InfoListLabel>
                <InfoListValue>{{ hotelInfo.zip_code }}</InfoListValue>

                <InfoListLabel>Mã số thuế</InfoListLabel>
                <InfoListValue>{{ hotelInfo.tax_code }}</InfoListValue> -->
              </InfoList>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="button-containers">
      <button
        :disabled="rowsSelected.length === 0"
        class="btn primary small outline"
        @click="deleteHotel"
      >
        {{ $t('button.delete') }}
      </button>
      <button
        :disabled="rowsSelected.length !== 1"
        class="btn primary small"
        @click="isEditHotelInfo"
      >
        {{ $t('button.modify') }}
      </button>
      <button
        class="btn primary small"
        :disabled="loading"
        @click="dialogFormVisible = true"
      >
        {{ $t('button.add') }}
      </button>
    </div>
    <el-dialog
      :visible.sync="dialogFormVisible"
      :title="isEdit ? 'Sửa khách sạn' : 'Thêm khách sạn'"
      width="700px"
      :close-on-click-modal="false"
      @close="resetInfo()"
    >
      <validation-observer ref="formAValidator">
        <div v-loading="addHotelDialogLoading" class="das-form-container">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-12 flex justify-center">
                <!-- <avatar-upload
                  ref="imgUpload"
                  :img-src="receivedImg"
                  :is-edit-mode="true"
                  @fileChanged="onHotelImgChange"
                /> -->
                <avatar-upload
                  ref="imgUpload"
                  :is-edit-mode="true"
                  @fileChanged="onHotelImgChange"
                />
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <validation-provider
                  rules="required|max:20"
                  name="ID khách sạn"
                >
                  <div class="das-form-input">
                    <div class="label required">ID khách sạn</div>
                    <div class="child-w-80">
                      <input
                        v-model="hotelSubmitForm.hotel_id"
                        :disabled="isEdit"
                        type="text"
                      />
                    </div>
                  </div>
                </validation-provider>
              </div>
              <div class="das-form-col col-6">
                <validation-provider rules="required|max:50" name="Tên">
                  <div class="das-form-input">
                    <div class="label required">Tên:</div>
                    <div class="child-w-80">
                      <input v-model="hotelSubmitForm.name" type="text" />
                    </div>
                  </div>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <validation-provider
                  rules="required|max:20"
                  name="Tên tiếng Anh"
                >
                  <div class="das-form-input">
                    <div class="label required">Tên tiếng Anh</div>
                    <div class="child-w-80">
                      <input v-model="hotelSubmitForm.name_en" type="text" />
                    </div>
                  </div>
                </validation-provider>
              </div>
              <div class="das-form-col col-6">
                <div class="flex gap-10">
                  <validation-provider
                    name="Tổng số phòng"
                    rules="required|number"
                  >
                    <div class="das-form-input">
                      <div class="label required">Tổng số phòng</div>
                      <input v-model="hotelSubmitForm.total_room" type="text" />
                    </div>
                  </validation-provider>
                  <!-- <validation-provider rules="required" name="Màu sắc">
                    <div class="das-form-input">
                      <div class="label">Chọn màu</div>
                      <div class="flex justify-center">
                        <el-color-picker
                          v-model="hotelInfo.color"
                        ></el-color-picker>
                      </div>
                    </div>
                  </validation-provider> -->
                </div>
              </div>
            </div>
            <!-- <div class="das-form-row">
              <div class="das-form-col col-6">
                <validation-provider rules="required" name="Quốc gia">
                  <div class="das-form-input">
                    <div class="label">Quốc gia:</div>
                    <div class="child-w-80">
                      <el-select
                        v-model="hotelSubmitForm.nation_id"
                        placeholder=""
                      >
                        <el-option
                          v-for="item in nationList"
                          :key="item.code"
                          :label="item.desc"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                </validation-provider>
              </div>
              <div class="das-form-col col-6">
                <validation-provider rules="required|max:100" name="Địa chỉ">
                  <div class="das-form-input">
                    <div class="label required">Địa chỉ:</div>
                    <div class="child-w-80">
                      <input v-model="hotelSubmitForm.address" type="text" />
                    </div>
                  </div>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <validation-provider
                  rules="required|positiveNum|max: 15"
                  name="Số điện thoại"
                >
                  <div class="das-form-input">
                    <div class="label required">Số điện thoại:</div>
                    <div class="child-w-80">
                      <input
                        v-model="hotelSubmitForm.phone_number"
                        v-numeric-only
                        type="text"
                      />
                    </div>
                  </div>
                </validation-provider>
              </div>
              <div class="das-form-col col-6">
                <validation-provider rules="required|fax|max:20" name="Fax">
                  <div class="das-form-input">
                    <div class="label required">Fax:</div>
                    <div class="child-w-80">
                      <input v-model="hotelSubmitForm.fax" type="text" />
                    </div>
                  </div>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <validation-provider rules="required|max:50" name="Tên công ty">
                  <div class="das-form-input">
                    <div class="label required">Tên công ty:</div>
                    <div class="child-w-80">
                      <input
                        v-model="hotelSubmitForm.company_name"
                        type="text"
                      />
                    </div>
                  </div>
                </validation-provider>
              </div>
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">Năm thành lập:</div>
                  <div class="child-w-80">
                    <input
                      v-model="hotelSubmitForm.founded_year"
                      v-numeric-only
                      type="number"
                      min="1900"
                      max="2099"
                      step="1"
                      value="2016"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <validation-provider rules="required|email" name="Email">
                  <div class="das-form-input">
                    <div class="label required">Email:</div>
                    <div class="child-w-80">
                      <input v-model="hotelSubmitForm.email" type="text" />
                    </div>
                  </div>
                </validation-provider>
              </div>
              <div class="das-form-col col-6">
                <validation-provider rules="required" name="Mã bưu điện">
                  <div class="das-form-input">
                    <div class="label required">Mã bưu điện:</div>
                    <div class="child-w-80">
                      <input v-model="hotelSubmitForm.zip_code" type="text" />
                    </div>
                  </div>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <validation-provider rules="required|tax" name="Mã số thuế">
                  <div class="das-form-input">
                    <div class="label required">Mã số thuế:</div>
                    <div class="child-w-80" style="cursor: not-allowed">
                      <input v-model="hotelSubmitForm.tax_code" type="text" />
                    </div>
                  </div>
                </validation-provider>
              </div>
            </div> -->
          </div>
        </div>
      </validation-observer>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="dialogFormVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
          <button v-if="isEdit" class="btn primary small" @click="updateHotel">
            {{ $t('button.update') }}
          </button>
          <button v-else class="btn primary small" @click="addNewHotel">
            {{ $t('button.create') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>
<script>
/* eslint-disable */
import bus from '@/utils/bus'
import AvatarUpload from '@/components/ui/avatarUpload.vue'
import { getListHotel, deleteHotel, getHotelInfoById } from '@/api/hotel.js'
import { getNationListApi } from '@/api/common/code'
import HotelSearch from './components/hotelSearch.vue'
export default {
  components: {
    HotelSearch,
    AvatarUpload
  },
  data() {
    return {
      loadingHotelView: false,
      rowsSelected: [],
      isEdit: false,
      searchParam: '',
      receivedImg: null,
      dialogFormVisible: false,
      showImgDialog: false,
      uploadedImg: null,
      loading: false,
      loading1: false,
      addHotelDialogLoading: false,
      nationList: [],
      currentRow: null,
      isEditMode: false,
      searchParams: {
        pageSize: null,
        pageNum: null,
        keyword: ''
      },
      hotelInfo: {
        address: null,
        company_name: null,
        create_date: null,
        create_user_id: null,
        email: null,
        address: null,
        hotel_id: null,
        fax: null,
        founded_year: null,
        hotel_id: null,
        id: null,
        logo: null,
        name: null,
        nation_id: null,
        nation_name: null,
        phone_number: null,
        represent: null,
        short_name: null,
        tax_code: null,
        website: null,
        zip_code: null
        // color: null
      },
      hotelSubmitForm: {
        hotel_id: null,
        name: null,
        name_en: null,
        total_room: null
        // address: null,
        // company_name: null,
        // create_date: null,
        // create_user_id: null,
        // email: null,
        // address: null,
        // fax: null,
        // founded_year: null,
        // hotel_id: null,
        // id: null,
        // logo: null,
        // nation_id: null,
        // nation_name: null,
        // phone_number: null,
        // represent: null,
        // short_name: null,
        // tax_code: null,
        // website: null,
        // zip_code: null
      },
      columns: [
        {
          headerName: 'Tên',
          field: 'name'
        }
      ],
      rows: [
        {
          hotel_id: 'M123',
          name: 'Mường thanh Hà Nội',
          create_date: '2023',
          short_name: 'Mường thanh',
          website: 'muongthanh2023.vn',
          nation_id: 'Viet nam',
          address: '32 Đê La Thành',
          phone_number: 19001221,
          fax: '1234',
          company_name: 'Mường thanh 1',
          founded_year: 2018,
          email: 'muongthanh@gmail.com',
          zip_code: 123,
          tax_code: 123
        }
      ]
      // initRows: []
    }
  },
  methods: {
    async deleteHotel() {
      this.$vxConfirm('Bạn chắc chắn muốn xóa khách sạn đã chọn?', async () => {
        const ids = this.rowsSelected.map(item => item.id) || null
        const data = {
          id_list: ids
        }
        await deleteHotel(data)
          .then(async res => {
            const message = res.message
            await this.attachData()
            this.$message({
              type: 'success',
              // message: this.$t(`successMsg.${message}`)
              message: 'Xóa khách sạn thành công'
            })
          })
          .catch(error => {
            const message = error.response?.data?.message || 'default'
            this.$message({
              type: 'error',
              message: this.$t(`errorMsg.${message}`)
            })
          })
      })
    },
    isEditHotelInfo() {
      Object.assign(this.hotelSubmitForm, this.rowsSelected[0])
      this.hotelSubmitForm.logo = null
      this.isEdit = true
      this.dialogFormVisible = true
      setTimeout(() => {
        this.$refs.imgUpload.onSetImgSrc(this.receivedImg)
      }, 200)
    },
    onResetParams() {
      this.$nullValueInObj(this.searchParams)
      this.attachData()
    },
    resetInfo() {
      this.isEdit = false
      // this.receivedImg = null
      this.$refs.imgUpload.onResetImgSrc()
      this.$nullValueInObj(this.hotelSubmitForm)
    },
    async addNewHotel() {
      if ((await this.$vxForm.isValid(this.$refs.formAValidator)) === false) {
        return
      }
      let formData = new FormData()
      formData.append('hotel', JSON.stringify(this.hotelSubmitForm))
      formData.append('logo', this.uploadedImg)
      this.addHotelDialogLoading = true
      this.$axios
        .post('/config-service/v1/hotel/hotel', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(async res => {
          const message = res.message
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
          this.attachData()
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
        .finally(() => {
          this.addHotelDialogLoading = false
        })
    },
    showIMG() {
      this.showImgDialog = true
    },
    onHotelImgChange(data) {
      this.uploadedImg = data
    },
    async getListNation() {
      let data = await getNationListApi()
      this.nationList = data.data
    },
    changeInfo() {
      this.isEditMode = true
    },
    async updateHotel() {
      if ((await this.$vxForm.isValid(this.$refs.formAValidator)) === false) {
        return
      }
      let formData = new FormData()
      formData.append('hotel', JSON.stringify(this.hotelSubmitForm))
      formData.append('logo', this.uploadedImg)
      this.addHotelDialogLoading = true
      this.$axios
        .put('/config-service/v1/hotel/hotel', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(async res => {
          this.$message({
            type: 'success',
            message: this.$t('successMsg.updateSuccess')
          })
          this.isEditMode = false
          this.dialogFormVisible = false
          this.attachData()
        })
        .catch(error => {
          const message = error?.response?.data?.message || 'updateError'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
        .finally(() => {
          this.addHotelDialogLoading = false
        })
    },
    cancelUpdateInfo() {
      this.$vxConfirm('Các thông tin thay đổi sẽ không được lưu?', () => {
        this.isEditMode = false
      })
    },
    async onSelectionChange(rows) {
      this.rowsSelected = rows
      this.loadingHotelView = true
      // view only
      const data = await getHotelInfoById(this.rowsSelected[0].id)
        .then(res => {
          Object.assign(this.hotelInfo, res.data)
        })
        .catch(() => {
          this.$message({
            message: 'Không thể lấy thông tin của khách sạn đã chọn',
            type: 'error'
          })
        })
        .finally(() => {
          this.loadingHotelView = false
        })
      // submit form
      // Object.assign(this.hotelSubmitForm, value)
      if (this.hotelInfo.logo) {
        this.receivedImg = 'data:image/png;base64,' + this.hotelInfo.logo
      } else {
        this.receivedImg = null
      }
      this.isEditMode = false
    },
    handleCurrentChange(val) {
      this.currentRow = val
    },
    handleDoubleClick(val) {},
    async attachData() {
      this.loading = true
      const data = await getListHotel(this.searchParams)
        .then(data => {
          this.rows = data.data
          this.receivedImg = null
          this.$nullValueInObj(this.hotelInfo)
          this.rowsSelected = []
        })
        .catch(() => {
          this.rows = []
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  created() {
    this.getListNation()
    // this.attachData()
  },
  beforeMount() {},
  watch: {
    // dialogFormVisible() {
    //   this.dialogFormVisible ? null : this.resetInfo()
    // }
  },
  mounted() {
    this.attachData()
  }
}
</script>
<style lang="scss" scoped>
.content-hotel {
  color: #409eff;
  font-weight: bold;
  p {
    margin: 16px 0;
  }
}
.hotel-image {
  position: relative;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em,
    rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em,
    rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset;
  cursor: pointer;
  &:hover {
    opacity: 0.7;
  }
}
.overlay {
  position: absolute;
  width: 100%;
  height: 20px;
  background: red;
}
</style>
